import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ContentChild, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { defaultGridOptions } from '../../models';
import { DxButtonModule } from 'devextreme-angular';
import { ClickEvent } from 'devextreme/ui/button';
import { TranslatePipe } from '../../pipes/translate.pipe';
// import { PageInfoService } from 'src/app/core/services/page-info.service';
// import { AuthorizationService } from 'src/app/core/services/authorization.service';
// import { ConfigurationService, IDataGridState } from 'src/app/core/services/configuration.service';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit, AfterContentInit {

  @Input()
  public id!: string;

  @Input()
  public title!: string;

  @Input()
  public showAdd!: boolean;

  @Input()
  public open: boolean = false;

  @Output()
  public onAdd: EventEmitter<ClickEvent> = new EventEmitter<ClickEvent>();

  @ContentChild(DxDataGridComponent)
  private dataGrid!: DxDataGridComponent;

  // public dataGridState: IDataGridState =
  // {
  //   UserId : null,
  //   GridId : "",
  //   State : "",
  // }
  
  // constructor(
  //   private pageInfoService: PageInfoService,
  //   private authorizationService: AuthorizationService,
  //   private configurationService: ConfigurationService
  // ) { 
  //   this.UserId = this.authorizationService.CurrentUser.Id;
  // }

  // public getGridStateData(){
  //   let grid = this.dataGrid?.instance?.element();
  //   if(!grid.id){
  //     let localState = localStorage.getItem(this.pageInfoService.getCurrentPageTitle());
  //     if(localState){
  //       this.dataGrid.instance.state(JSON.parse(localState));
  //   }
  //   }
  //   if(grid.id){
  //     this.configurationService.getDataGridStateByGridId(grid.id,this.UserId)
  //           .then((response:any)=>{
  //             if(response.Data){
  //               this.dataGridState.State = response.Data.State;
  //             if (this.dataGrid && this.dataGrid.instance && this.dataGridState.State) {
  //             this.dataGrid.instance.state(JSON.parse(this.dataGridState.State));
  //               }
  //             } 
  //           });  
  //   }
  // }
  
  private UserId!: number;
  public grids: Array<any> = [];
  public selectedIndex = -1;
  ngOnInit(): void {
    this.selectedIndex = this.open ? 0 : -1;
    this.grids = [
      {
        title: this.title
      }
    ]
    // this.dataGridState.UserId = this.UserId;
    // this.dataGridState.GridId = this.dataGrid?.instance?.element().id;
  }

  ngAfterContentInit(): void {
    // this.dataGrid.instance.option("columnChooser", { enabled: true });
    this.dataGrid.instance.option(defaultGridOptions);
    // this.dataGrid.instance.showColumnChooser();
    // this.dataGridState.GridId = this.dataGrid?.instance?.element().id;
    // if(!this.dataGridState.GridId)
    // {
    //  localStorage.setItem(this.pageInfoService.getCurrentPageTitle(), JSON.stringify(this.dataGrid.instance.state())); 
    // }
    // else{
    //   this.dataGridState.State = JSON.stringify(this.dataGrid.instance.state());
    //   this.configurationService.addDataGridStateGridID(this.dataGridState)
    //     .then((response : any )=> {
    //      // this.response;
    //      });
    //  }
  }

  onAddClicked = (event: ClickEvent) =>{
    this.onAdd && this.onAdd.emit(event);
  }
}
